import { PayFitColor } from '../../types/module';

export const applyBackgroundColor = (color: PayFitColor): string => {
  switch (color) {
    case 'blue':
      return 'bg-blue-21';
    case 'azur':
      return 'bg-azur-21';
    case 'coral':
      return 'bg-coral-21';
    case 'mint':
      return 'bg-mint-21';
    case 'purple':
      return 'bg-purple-21';
    case 'yellow':
      return 'bg-yellow-21';
    case 'neutral':
      return 'bg-neutral-21';
    case 'grey':
      return 'bg-silver-21';
    default:
      return 'bg-neutral-1';
  }
};
